export const percentToPixel = (convert: number, hundred: number) => {
  return (convert * hundred) / 100
}
